import { put, take, call } from 'redux-saga/effects';

import { setRootView } from '../views/actions';
import { stopExplicitWaiting } from '../wait/actions';
import { SET_BROWSER_DETAILS, IGNORE_UNSUPPORTED_BROWSER } from './actions';

export function* watchSetBrowserDetails() {
    // This action is only fired once, when the app initialises
    const action = yield take(SET_BROWSER_DETAILS);
    yield call(function*(action) {
        if (action.oldVersion || action.missingFeature) {
            yield put(stopExplicitWaiting());
            yield put(setRootView({ type: 'unsupported-browser' }));
        }
    }, action);
}

export function* awaitIgnoreUnsupportedBrowser() {
    yield take(IGNORE_UNSUPPORTED_BROWSER);
}
